module.exports = __webpack_public_path__ + "static/img/btn_quiz_result.e928236.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_quiz_result.svg
// module id = 89
// module chunks = 0